import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneSettingPayload {
    settingId: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IOneSettingState {
    status: string
    data: any
    errors: any
}

const initialState: IOneSettingState = {
    status: STATUS.IDLE,
    data: {},
    errors: null
}

const oneSetting = createSlice({
    name: 'event-setting/one',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneSettingPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneSettingActions = oneSetting.actions
export default oneSetting.reducer
